import type { ExtractedMessages } from '@Infra/FetchLib/ApiError/extractMessages';

export type FacilityUpdateFailedAction = {
	type: 'FACILITY_UPDATE_FAILED';
	payload: ExtractedMessages;
};

export default (payload: ExtractedMessages): FacilityUpdateFailedAction => ({
	type: 'FACILITY_UPDATE_FAILED',
	payload,
});
